import { DrilldownPath } from '../_models/drilldown';

export class HeaderData {
  title: String;
  path: Array<DrilldownPath> = [];
  type: String;

  constructor(title: String, path?: Array<DrilldownPath>) {
    this.title = title;
    if (path) this.path = path;
  }
}



// WEBPACK FOOTER //
// ./src/app/header/headerData.ts